/*
 jquery-circle-loading-slider
 Version: 1.0.0
 Author: Yoshikazu Sugata
 License: MIT
 */
(function($){
    $.fn.slider = function(options){
        // デフォルトオプション設定
        let defaultOption = {
            speed: 4000,    // スライダーの切り替わる時間
        };
        // ユーザーオプション設定とマージする
        var opt = $.extend(defaultOption, options);
        
        // スライダーの表示
        function showSlide(index, slideItems){
            // 全スライドからshow_slideを除去
            slideItems.removeClass("show_slide");
            // 表示させたい対象だけshow_slideを再付与
            slideItems.eq(index).addClass("show_slide");
        }
        
        // スライドコントローラーを生成
        function addController(_this, slideItems, timer){

            let controllerElem = '<ul class="slide_controller"></ul>';

            let controllerItemElem = '<li><span class="slide_number"></span><svg class="timer_circle"><circle cx="0" cy="0" r="0" fill="none" style="stroke-dashoffset: 0;stroke-dasharray: 0;"></circle></svg></li>';
            
            // コントローラー要素を作成
            let ulInst = $(controllerElem);
            
            slideItems.each(function(index, item){
                // コントローラーアイテムを生成
                let liInst = $(controllerItemElem);
                // 0埋めしたindex + 1を表示する
                liInst.find(".slide_number").text(_zeroPad(index + 1));
                // 1個目のコントローラーにactiveを付与する
                if(index === 0){
                    liInst.addClass("active");
                }
                // clickイベントを付与
                liInst.on("click", function(){
                    changeSlide(index, slideItems, _this, timer);
                });
                
                // 要素として追加
                ulInst.append(liInst);
            });
            
            // コントローラー要素を追加
            _this.append(ulInst);
            
            // 円タイマーのサイズを取得する
            let circleWidth = _this.find(".timer_circle").width();
            let circleStrokeWidth = parseFloat(_this.find(".timer_circle circle").css("stroke-width"));
            // 円タイマーに設定する値を計算する
            let cxy = circleWidth / 2;
            let r = cxy - circleStrokeWidth / 2;
            let dasharray = Math.PI * 2 * r;
            // 円タイマーに値を設定
            _this.find(".timer_circle circle").attr("cx", cxy);
            _this.find(".timer_circle circle").attr("cy", cxy);
            _this.find(".timer_circle circle").attr("r", r);
            _this.find(".timer_circle circle").css("stroke-dashoffset", dasharray);
            _this.find(".timer_circle circle").css("stroke-dasharray", dasharray);
        }
        
        // スライダーの変更
        function changeSlide(index, slideItems, _this, timer){
            // 現在表示中のスライドに対応したコントローラー要素をactiveにする
            let slideContItems = _this.find(".slide_controller li");
            slideContItems.removeClass("active");
            slideContItems.eq(index).addClass("active");
            
            // スライドの表示
            showSlide(index, slideItems);
            
            // タイマーを設定
            autoSlide(timer, index, slideItems, _this);
        }
        
        // スライダー自動再生
        function autoSlide(timer, slideIndex, slideItems, _this){
            
            // 既存のタイマー表示をリセットする
            let resetDasharray = parseFloat( _this.find(".slide_controller li .timer_circle circle").css("stroke-dasharray") );
            _this.find(".slide_controller li .timer_circle circle").css("stroke-dashoffset", resetDasharray);
            
            // 既存タイマーをクリア
            clearInterval(timer[0]);
            
            timer[0] = setInterval(function(){
                // タイマー動作対象を取得
                let target = _this.find(".slide_controller li").eq(slideIndex);
                let maxDasharray = parseFloat( target.find(".timer_circle circle").css("stroke-dasharray") );
                // 10ミリ秒で減算する数値を計算
                let division = maxDasharray / (opt["speed"] / 10);
                // 現在のdashoffsetを取得
                let nowDashoffset = parseFloat( target.find(".timer_circle circle").css("stroke-dashoffset") );
                
                if(nowDashoffset < 0){
                    // 既にタイマーが回りきっている場合は次の要素の表示を行う
                    let slideCount = slideItems.length;
                    slideIndex++;
                    if(slideIndex >= slideCount){
                        // スライダーの最大値を超えているので、最初のスライドに戻す
                        slideIndex = 0;
                    }
                    // スライドを変更
                    changeSlide(slideIndex, slideItems, _this, timer);
                } else {
                    // タイマーが回りきっていないので、現在の要素の表示を行う
                    // dashoffsetに設定する値を計算
                    let dashoffset = nowDashoffset - division;
                    // dashoffsetに値を設定
                    target.find(".timer_circle circle").css("stroke-dashoffset", dashoffset);
                }
            }, 10);
        }
        
        // 0埋め
        function _zeroPad(num){
            return ("00" + num ).slice(-2);
        }
        
        $(this).each(function(){
            // タイマー格納配列(index 0のみ使用)
            var timer = [];
            
            // スライド要素としてog_sliderクラスを付与する
            $(this).addClass("og_slider");
            
            // スライド対象を取得
            let slideItems = $(this).find("> *");
            slideItems.addClass("slide_item");
            
            // スライド対象数を取得
            let slideCount = slideItems.length;
            
            // スライド対象がない、または1件の場合はそのまま表示する
            if(slideCount < 2){
                return true;
            }
            
            // コントローラーを生成
            addController($(this), slideItems, timer);
            
            // 最初のスライドを表示
            changeSlide(0, slideItems, $(this), timer);
        });
    }
})(jQuery);


